export default "__VITE_ASSET__BnGc$H9n__"